import { jsx as _jsx } from "react/jsx-runtime";
import ContentCard from '../TrackCard/ContentCard';
import { useCallback, useMemo } from 'react';
import UsageTracker from '../../utils/UsageTracker'; // @ts-expect-error Could not find a declaration file for module

import useFilterParams from '../../hooks/useFilterParams';
import { useLesson } from '../../features/lessons'; // @ts-expect-error Could not find a declaration file for module

import { useSearchParamInput } from '../../hooks/searchParamHooks';
import { getListingUrl } from '../../utils/RoutingUtils';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { useLocation } from 'react-router-dom';
import LessonThumbnailOverlayed from '../TrackCard/Thumbnail/LessonThumbnailOverlayed';
import { useAssetStatus } from '../../features/userProgress';

const LessonCardContainer = ({
  lessonId,
  isFlushOnMobile = true,
  position,
  appearsIn,
  isGhost,
  onClick,
  footer,
  thumbnailHeaderIcons,
  preferPreviewModal,
  language: forceLanguage
}) => {
  const filterParams = useFilterParams();
  const {
    status
  } = useAssetStatus({
    id: lessonId,
    type: 'LESSON'
  });
  const isStarted = status && status !== 'NOT_STARTED';
  const location = useLocation();
  const [languages, __] = useSearchParamInput(FILTER_TYPES.LANGUAGE, false);
  const language = forceLanguage || languages.length ? languages[0] : undefined;
  const {
    lesson
  } = useLesson(lessonId, language);
  const onClickHandler = useCallback(() => {
    if (!lesson) return;
    const {
      name,
      lessonType
    } = lesson;
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'LESSON',
      lessonId,
      lessonType: lessonType[0],
      appearsIn,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default',
      isInProgress: isStarted
    });
    if (onClick) onClick(lessonId);
  }, [appearsIn, filterParams, isStarted, lesson, lessonId, onClick, position]);
  const to = useMemo(() => {
    if (!lesson) return null;
    const {
      id
    } = lesson;
    const {
      pathname,
      search
    } = location;
    const url = getListingUrl({
      type: 'LESSON',
      isStarted: preferPreviewModal !== undefined ? !preferPreviewModal : isStarted,
      id,
      language,
      currentPathname: pathname,
      currentSearch: search,
      appearsIn
    });
    return {
      pathname: url.pathname,
      search: url.search,
      state: {
        backLocation: location
      }
    };
  }, [lesson, location, preferPreviewModal, isStarted, language, appearsIn]);

  if (!lesson) {
    return null;
  }

  const {
    name,
    description
  } = lesson;
  return /*#__PURE__*/_jsx(ContentCard, {
    "data-test-is-unfilterable": false,
    "data-test-meta": lessonId,
    "data-test-type": "lesson",
    description: description,
    footer: footer,
    isFlushOnMobile: isFlushOnMobile,
    isGhost: isGhost,
    name: name,
    onClick: onClickHandler,
    thumbnailOverlayed: /*#__PURE__*/_jsx(LessonThumbnailOverlayed, {
      headerIcons: thumbnailHeaderIcons,
      isGhost: isGhost,
      language: language,
      lessonId: lessonId
    }),
    to: to
  });
};

export default LessonCardContainer;